export default {"src":"/_next/static/media/Empty_impact.97cf588c.svg","height":165,"width":171,"blurWidth":0,"blurHeight":0};